import "../../css/pages/campaignThankYV3.scss";
import BasePage from "./base";
import sectionNav from "../modules/sectionNav";
import tabsToggle from "../modules/tabsToggle";
import accordion from "../modules/accordion";

class campaignThankYV3Page extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();

        sectionNav.init();
        tabsToggle.init();
        window.addEventListener("load", accordion.init);
    }
}

new campaignThankYV3Page();
